import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";

var _dec, _class, _class2, _temp;

/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import themeable from '@instructure/ui-themeable';
import captionUtils from '../../../utils/caption';
import { tracksType } from '../PropTypes';
var styles = {
  componentId: 'bQfsg',
  template: function template(theme) {
    return "\n\n.bQfsg_dBml{line-height:1.5;pointer-events:none;position:absolute;text-align:center}\n\n[dir=ltr] .bQfsg_dBml,[dir=rtl] .bQfsg_dBml{text-align:center}\n\n.bQfsg_fjhh{background-color:".concat(theme.captionBackgroundColor || 'inherit', ";color:").concat(theme.captionTextColor || 'inherit', ";padding:0.375rem}");
  },
  'subtitleContainer': 'bQfsg_dBml',
  'subtitle': 'bQfsg_fjhh'
};
import theme from './theme';
var ENTER = /[\r\n]/g;
export var START_POSITION = 1;
export var CONTROLS_SHOWN_OFFSET = 4;
var CaptionsPres = (_dec = themeable(theme, styles), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(CaptionsPres, _Component);

  function CaptionsPres() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, CaptionsPres);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(CaptionsPres)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      activeCues: []
    };
    _this.lookupIdx = 0;

    _this.getCaptionPosition = function (_ref) {
      var captionPosition = _ref.captionPosition,
          showControls = _ref.showControls,
          captionOffset = _ref.captionOffset;

      if (typeof captionOffset === 'string') {
        return captionOffset;
      } else if (typeof captionOffset === 'number') {
        var startingPosition = captionPosition === 'bottom' && showControls ? CONTROLS_SHOWN_OFFSET + START_POSITION : START_POSITION;
        return "".concat(startingPosition + captionOffset, "rem");
      }
    };

    return _this;
  }

  _createClass(CaptionsPres, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var activeCues = captionUtils.getActiveCues(this.props, prevProps, this);

      if (captionUtils.activeCuesChanged(prevState.activeCues, activeCues)) {
        this.setState({
          activeCues: activeCues
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _ref2;

      var captions = this.props.captions;

      if (!Array.isArray(captions) || captions.length === 0) {
        return null;
      }

      var captionPosition = this.props.captionPosition;
      return React.createElement("div", {
        className: styles.subtitleContainer,
        style: (_ref2 = {}, _defineProperty(_ref2, captionPosition, this.getCaptionPosition(this.props)), _defineProperty(_ref2, "transition", "".concat(captionPosition, " 0.25s ease-in-out")), _ref2)
      }, this.state.activeCues.map(function (_ref3) {
        var text = _ref3.text;
        return text.split(ENTER).map(function (lineContent) {
          // Caption files can provide multiple entries for a single time slot.
          // Display each entry separated by a single line to emulate native behaviour.
          return React.createElement("div", {
            key: lineContent
          }, React.createElement("span", {
            className: styles.subtitle
          }, lineContent));
        });
      }));
    }
  }]);

  CaptionsPres.displayName = "CaptionsPres";
  return CaptionsPres;
}(Component), _class2.propTypes = {
  currentTime: PropTypes.number.isRequired,
  captions: PropTypes.arrayOf(PropTypes.shape({
    start: PropTypes.number,
    end: PropTypes.number,
    text: PropTypes.string
  })),
  captionPosition: PropTypes.oneOf(['top', 'bottom', 'left', 'right']),
  captionOffset: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  showControls: PropTypes.bool
}, _class2.defaultProps = {
  captions: [],
  captionPosition: 'top',
  captionOffset: 0,
  showControls: false
}, _temp)) || _class);

var Captions = /*#__PURE__*/function (_Component2) {
  _inherits(Captions, _Component2);

  function Captions(props) {
    var _this2;

    _classCallCheck(this, Captions);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(Captions).call(this, props));
    _this2.state = {
      captions: [],
      convertedTracks: {}
    };

    _this2.clearUnneededConvertedTracks = function (tracks, staleTracks) {
      var callback = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : function () {};

      _this2.setState(function (prevState) {
        var tracksToKeep = staleTracks.filter(function (_ref4) {
          var staleId = _ref4.id;
          return tracks.some(function (track) {
            return staleId === track.id;
          });
        });
        var convertedTracks = tracksToKeep.reduce(function (result, _ref5) {
          var id = _ref5.id;
          var convertedTrack = prevState.convertedTracks[id];

          if (!convertedTrack) {
            return result;
          }

          return _objectSpread({}, result, _defineProperty({}, id, convertedTrack));
        }, {});
        return {
          convertedTracks: convertedTracks
        };
      }, callback);
    };

    _this2.maybeDefaultToOff = function () {
      var _this2$state = _this2.state,
          convertedTracks = _this2$state.convertedTracks,
          captions = _this2$state.captions;
      var currentCaptions = Object.values(convertedTracks).find(function (cachedCaptions) {
        return cachedCaptions === captions;
      });

      if (!currentCaptions) {
        _this2.toggleTrack(0); // TODO: change `0` to `null` once INSTUI-2429 is resolved

      }
    };

    _this2.findSelectedTrack = function (tracks, trackId) {
      return tracks.find(function (track) {
        return track.id === trackId;
      });
    };

    _this2.toggleTrack = function (trackId) {
      var selectedTrack = _this2.findSelectedTrack(_this2.props.tracks, trackId);

      var selectedTrackSrc = selectedTrack && selectedTrack.src;
      var selectedTrackId = selectedTrack && selectedTrack.id;

      var applyTrack = function applyTrack() {
        _this2.setState({
          captions: selectedTrackId ? _this2.state.convertedTracks[selectedTrackId] : []
        });

        _this2.props.onTrackChange(trackId);
      };

      if (selectedTrack && !_this2.state.convertedTracks[selectedTrackId]) {
        return captionUtils.getCaptionsFromFile(selectedTrackSrc).then(function (captionData) {
          var sortedCaptionData = captionUtils.sortByTime(captionData);

          _this2.setState(function (prevState) {
            return {
              convertedTracks: _objectSpread({}, prevState.convertedTracks, _defineProperty({}, selectedTrackId, sortedCaptionData))
            };
          }, applyTrack);
        }).catch(function (message) {
          window.console.warn(message);
          applyTrack();
          return Promise.reject(message);
        });
      } else {
        applyTrack();
      }

      return Promise.resolve();
    };

    _this2.props.setActions({
      toggleTrack: _this2.toggleTrack
    });

    return _this2;
  }

  _createClass(Captions, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.tracks !== this.props.tracks) {
        this.clearUnneededConvertedTracks(this.props.tracks, prevProps.tracks, this.maybeDefaultToOff);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(CaptionsPres, Object.assign({}, this.props, this.state));
    }
  }]);

  Captions.displayName = "Captions";
  return Captions;
}(Component);

Captions.propTypes = _objectSpread({
  tracks: tracksType,
  setActions: PropTypes.func,
  onTrackChange: PropTypes.func
}, CaptionsPres.propTypes);
Captions.defaultProps = _objectSpread({
  tracks: [],
  setActions: function setActions() {},
  onTrackChange: function onTrackChange() {}
}, CaptionsPres.defaultProps);
export { Captions as default };
export { Captions, CaptionsPres };